import { memo, useState } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
//Local files
import BaseDialog from 'components/Common/Feedback/BaseDialog/BaseDialog';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Password = ({ open, onClose, onChange }) => {
  const [password, setPassword] = useState({ value: '', error: '' });
  const [repeatPassword, setRepeatPassword] = useState({ value: '', error: '' });
  const [showPasswordSymbols, setShowPasswordSymbols] = useState(false);

  const handleChange = () => {
    let hasError = false;

    if (!password.value) {
      setPassword(prev => ({ ...prev, error: `Password can't be empty` }));
      hasError = true;
    }
    if (!repeatPassword.value) {
      setRepeatPassword(prev => ({ ...prev, error: `Password can't be empty` }));
      hasError = true;
    }
    if (!!password.value && !!repeatPassword.value && password.value !== repeatPassword.value) {
      setPassword(prev => ({ ...prev, error: `Passwords must be the same` }));
      setRepeatPassword(prev => ({ ...prev, error: `Passwords must be the same` }));
      hasError = true;
    }
    if (hasError) return;

    onChange(null, password.value);
    onClose();
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      otherPaperStyle={{ width: '100%', maxWidth: 360 }}
      title='Change current password'
      actions={
      <>
        <Button variant='outlined' sx={{ minWidth: 110 }} onClick={onClose}>Cancel</Button>
        <Button variant='contained' color='primary' sx={{ minWidth: 110 }} onClick={handleChange}>Save</Button>
      </>
      }
      content={
        <Box px={5} pb={2}>
          {/* <TextField
            fullWidth
            margin='normal'
            label='Enter your old password'
            type={showPasswordSymbols ? 'text' : 'password'}
          /> */}
          <TextField
            fullWidth
            margin='normal'
            label='Enter new password'
            type={showPasswordSymbols ? 'text' : 'password'}
            value={password.value}
            onChange={({ target: { value } }) => setPassword({ value, error: '' })}
            error={!!password.error}
            helperText={password.error}
          />
          <TextField
            fullWidth
            margin='normal'
            label='Repeat new password'
            type={showPasswordSymbols ? 'text' : 'password'}
            value={repeatPassword.value}
            onChange={({ target: { value } }) => setRepeatPassword({ value, error: '' })}
            error={!!repeatPassword.error}
            helperText={repeatPassword.error}
          />
          <FormControlLabel
            label="Show symbols"
            control={
              <Checkbox
                checked={showPasswordSymbols}
                onChange={(e) => setShowPasswordSymbols(e.target.checked)}
              />
            }
          />
        </Box>
      }
    />
  )
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Password {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);